import { RootState } from "../reducers";
import { GeometryEditorMode, GeometryEditorState } from "./geometryEditor";

export const isEditorActive = ({ geometryEditor }: RootState): boolean => geometryEditor && geometryEditor.active;

export const getGeometryEditor = ({ geometryEditor }: RootState): GeometryEditorState => geometryEditor;

export const getGeometryEditorMode = ({ geometryEditor }: RootState): GeometryEditorMode =>
  geometryEditor && geometryEditor.mode;
